import styled from "styled-components";
import colors from "../config/colors";
import arrowSvg from "../images/arrow.svg";

const List = styled.ul`
  color: ${colors.text};
  margin: 0;
  padding: 0 0 0 1.5rem;
  list-style: none;
`;

const ListItem = styled.li`
  font-size: 1.1rem;
  margin-bottom: 0.2rem;
  line-height: 1.5;
  &:before {
    position: absolute;
    content: "";
    width: 19px;
    height: 19px;
    margin-left: -1.5rem;
    margin-top: 0.25rem;
    background: url(${arrowSvg}) no-repeat;
  }
`;

List.ListItem = ListItem;

export default List;



// WEBPACK FOOTER //
// ./src/components/List.js